// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2k4gk","screen":"styles_screen__2E68x"};